import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";

import ResourceCard, { ResourceCardContentProps } from "./resource-card";

const resourceCardStyling = css({
    display: "flex",
    flexDirection: "column"
});

const PricingQuotesResourceCards = () => {
    const intl = useIntl();

    const getEstimateText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.GetEstimate",
        defaultMessage: "Get estimate"
    });
    const compareCosts = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CompareCosts",
        defaultMessage: "Compare costs"
    });
    const enterSENsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.enterSENs",
        defaultMessage: "Enter SENs"
    });

    const pricingQuotesResourceCards: ResourceCardContentProps[] = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudPricing",
                defaultMessage: "Cloud pricing calculator"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudPricing.dsc",
                defaultMessage:
                    "Estimate your bill for key Cloud products on Premium plans."
            }),
            buttonText: getEstimateText,
            url: useLocalizedHref("/software/pricing-calculator")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudValue",
                defaultMessage: "Cloud value calculator"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.CloudValue.dsc",
                defaultMessage:
                    "Compare the total cost of your server products to Cloud."
            }),
            buttonText: compareCosts,
            url: useLocalizedHref("/migration/assess/calculate-pricing")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.DataCenter",
                defaultMessage: "Data Center comparison"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.PricingQuotes.ResourceCard.DataCenter.dsc",
                defaultMessage:
                    "See what it would cost to upgrade your server SENs to Data Center."
            }),
            buttonText: enterSENsText,
            url: useLocalizedHref("/purchase/upgrade/datacenter")
        }
    ];

    return (
        <div css={resourceCardStyling}>
            {pricingQuotesResourceCards.map((cardProps) => (
                <ResourceCard {...cardProps} key={cardProps.header} />
            ))}
        </div>
    );
};

export default PricingQuotesResourceCards;
